import { render } from "./KnowledgeResourceAdmin.vue?vue&type=template&id=a8aec71c&scoped=true"
import script from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"

import "./KnowledgeResourceAdmin.vue?vue&type=style&index=0&id=a8aec71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8aec71c"]])

export default __exports__